import Vue from 'vue'
import Vuex from 'vuex'
import api from './api/api'
import logger from './utils/log'

Vue.use(Vuex)

const CONST_LOCAL_STORAGE = {
  REFRESH: 'CONST_LOCAL_STORAGE_REFRESH',
  TOKEN: 'CONST_LOCAL_STORAGE_TOKEN',
  INFO: 'CONST_LOCAL_STORAGE_INFO'
}

export default new Vuex.Store({
  state: {
    refresh:null,
    token: null,
    info: null
  },
  getters: {
    refresh: function(state) {
      console.log("state:"+state.refresh);
      
      if (!state.refresh) {
        console.log("storage:"+localStorage.getItem(CONST_LOCAL_STORAGE.REFRESH));
        state.refresh = localStorage.getItem(CONST_LOCAL_STORAGE.REFRESH)
      }
      return state.refresh
    },
    token: function(state) {
      console.log("state:"+state.token);
      
      if (!state.token) {
        console.log("storage:"+localStorage.getItem(CONST_LOCAL_STORAGE.TOKEN));
        state.token = localStorage.getItem(CONST_LOCAL_STORAGE.TOKEN)
      }
      return state.token
    },
    info: function(state) {
      if (!state.info) {
        state.info = JSON.parse(localStorage.getItem(CONST_LOCAL_STORAGE.INFO))
      }
      return state.info
    }
  },
  mutations: {
    updateRefreshToken(state, refresh) {
      state.refresh = refresh
      localStorage.setItem(CONST_LOCAL_STORAGE.REFRESH, refresh)
      logger.d('store', 'updateRefreshToken', {
        refresh: state.refresh
      })
    },
    updateToken(state, token) {
      state.token = token
      localStorage.setItem(CONST_LOCAL_STORAGE.TOKEN, token)
      logger.d('store', 'updateToken', {
        token: state.token
      })
    },
    updateInfo(state) {
      api.employee.queryOne({
        token: state.token
      }).then(data => {
        state.info = data.data.result.employee
        localStorage.setItem(CONST_LOCAL_STORAGE.INFO, JSON.stringify(state.info))
        logger.d('store', 'updateInfo', {
          info: state.info
        })
      }).catch(err => {
        logger.e('store', 'updateInfo', {
          err: err
        })
      })
    },
    logout(state) {
      state.refresh = null
      state.token = null
      state.info = null
      localStorage.removeItem(CONST_LOCAL_STORAGE.REFRESH)
      localStorage.removeItem(CONST_LOCAL_STORAGE.TOKEN)
      localStorage.removeItem(CONST_LOCAL_STORAGE.INFO)
    }
  },
  actions: {
    updateRefreshToken(context, refresh) {
      context.commit('updateRefreshToken', refresh)
    },
    updateToken(context, token) {
      context.commit('updateToken', token)
    },
    updateInfo(context) {
      context.commit('updateInfo')
    },
    logout(context) {
      context.commit('logout')
    }
  }
})
